import { Component, Input, Output, OnChanges, SimpleChanges, OnDestroy, EventEmitter } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms'
import { Subscription } from 'rxjs/Subscription';

import { WaveSingle } from '../../../../../../models/program/wave-single';

@Component({
  selector: 'differs-warning',
  templateUrl: './wave-differs-warning.component.html',
  styleUrls: ['./wave-differs-warning.component.less']
})

/**
 * This component monitors the wave description and form and display a warning if
 * the specified control has been modified and is marked as differing between
 * groups. It displays an undo link to the user which resets the control value to
 * it's blank state.
 */
export class WaveDiffersWarningComponent implements OnChanges, OnDestroy {
	@Input() form: FormGroup;
	@Input() retrievedWaveSettingsValues: WaveSingle;
	@Input() controlName: string;
  @Input() releaseIndex: number = null;
  @Output() undone: EventEmitter<void> = new EventEmitter<void>();

  private formSubscription: Subscription = null;
  public isVisible: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['form']) {
      this.listenForFormChanges();
    }
    this.setVisibility();
  }

  ngOnDestroy() {
    if(this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  private listenForFormChanges(){
    if(this.formSubscription) {
      this.formSubscription.unsubscribe();
      this.formSubscription = null;
    }
    if(this.form) {
      this.formSubscription = this.form.valueChanges.subscribe(value => this.setVisibility());
    }
  }

  private setVisibility() {
    if(typeof(this.releaseIndex) === 'number') {
      this.isVisible = !!(
        this.retrievedWaveSettingsValues &&
        this.retrievedWaveSettingsValues._release_differs[this.retrievedWaveSettingsValues.fm_releases[this.releaseIndex].id] &&
        this.form &&
        (this.form.controls['fm_releases'] as FormArray).controls[this.releaseIndex].dirty &&
        (this.form.controls['fm_releases'] as FormArray).controls[this.releaseIndex].value.release !==
          this.retrievedWaveSettingsValues['fm_releases'][this.releaseIndex].release);
    }
    else {
      this.isVisible = !!(
        this.retrievedWaveSettingsValues &&
        this.controlName &&
        this.retrievedWaveSettingsValues._differs[this.controlName] &&
        this.form && this.form.controls[this.controlName].dirty) &&
        this.form.controls[this.controlName].value !== this.retrievedWaveSettingsValues[this.controlName];
    }
  }

  private undo() {
    let originalValue, formControl;
    if(typeof(this.releaseIndex) === 'number') {
      originalValue = this.retrievedWaveSettingsValues.fm_releases[this.releaseIndex].release;
      let releaseGroup = (this.form.controls['fm_releases'] as FormArray).controls[this.releaseIndex] as FormGroup;
      formControl = releaseGroup.controls['release'];
    }
    else {
      originalValue = this.retrievedWaveSettingsValues[this.controlName];
      formControl = this.form.controls[this.controlName];
    }

    if(formControl instanceof FormArray) {
      while(formControl.length) {
        formControl.removeAt(0);
      }
    }
    formControl.reset(originalValue);
    this.undone.emit();
    this.setVisibility();
    return false;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component.ts